/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAgentGroup } from '../../models/api-response-list-agent-group';

export interface GetAssignableGroups$Params {
  'x-api-requestId'?: string;
  'x-api-canal'?: string;
  companyId?: string;
}

export function getAssignableGroups(http: HttpClient, rootUrl: string, params?: GetAssignableGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgentGroup>> {
  const rb = new RequestBuilder(rootUrl, getAssignableGroups.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAgentGroup>;
    })
  );
}

getAssignableGroups.PATH = '/v1/api/ui/agent-groups/options';
